import 'flickity/dist/flickity.pkgd.js'
// import 'flickity-fade/flickity-fade.js'

var autoplay = $('.carousel').attr('data-caraousel-autoplay') === 'true' ? true : false
$('.carousel').flickity({
	pageDots: true,
	prevNextButtons: true,
	adaptiveHeight: true,
	wrapAround: true,
	watchCSS: true,
	autoPlay: autoplay,
	imagesLoaded: true,
	// arrowShape: 'M0,50L48.5,6.2l3.5,4L22.6,39.9c-2.4,2.6-3.5,4.5-3.5,5.6c0,1.2,1.4,1.9,4,1.9H100v5.2H23.1c-2.8,0-4.2,0.7-4.2,2.4c0,1.2,1.2,3.1,3.5,5.4L52,89.8l-3.5,4L0,50z',
	arrowShape: 'M69.6895,99.3965L21,50.0645L21.6836,49.3652L69.6836,0L71.1191,1.39453L23.8027,50.0566L71.1133,97.9961L69.6895,99.3965Z',
})